/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum APIStatus1d2Enum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


export function instanceOfAPIStatus1d2Enum(value: any): boolean {
    for (const key in APIStatus1d2Enum) {
        if (Object.prototype.hasOwnProperty.call(APIStatus1d2Enum, key)) {
            if (APIStatus1d2Enum[key as keyof typeof APIStatus1d2Enum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function APIStatus1d2EnumFromJSON(json: any): APIStatus1d2Enum {
    return APIStatus1d2EnumFromJSONTyped(json, false);
}

export function APIStatus1d2EnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIStatus1d2Enum {
    return json as APIStatus1d2Enum;
}

export function APIStatus1d2EnumToJSON(value?: APIStatus1d2Enum | null): any {
    return value as any;
}

